import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=2066f982&scoped=true"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"
import style0 from "./HeroSlider.vue?vue&type=style&index=0&id=2066f982&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2066f982",
  null
  
)

export default component.exports